import { FC } from "react";
import OrderOptimizerRailyDetailsShowDrivingRouteComponent from "./elements/order-optimizer-raily-details-show-driving-route.component";
import OrderOptimizerRailyDetailsItem from "../common/types/order-optimizer-raily-details-item";

type OrderOptimizerRailyDetailsToolsProps = {
  details?: OrderOptimizerRailyDetailsItem;
  isDriverSelected: boolean;
  isButtonClicked: boolean;
  handleAddHomeMapMarker: () => void;
};

const OrderOptimizerRailyDetailsToolsComponent: FC<
  OrderOptimizerRailyDetailsToolsProps
> = (props) => {
  return (
    <div className="order_optimizer_raily_details_tools">
      <OrderOptimizerRailyDetailsShowDrivingRouteComponent
        details={props.details!}
        onSuccess={props.handleAddHomeMapMarker}
        isButtonClicked={props.isButtonClicked}
        idDisabled={!props.isDriverSelected}
      />
    </div>
  );
};

export default OrderOptimizerRailyDetailsToolsComponent;
